import IPermissions from '../interface/user/IPermissions';
import { IUserSecurityDto } from '../interface/user/IUserSecurityDto';

export const AuthPermissions = (currentUser: IUserSecurityDto): IPermissions => {
  function findRule(ruleToSearch: string): boolean {
    return true;
    // let hasRule = false;

    // if (currentUser?.profiles) {
    //   currentUser?.profiles?.forEach(profile => {
    //     if (profile?.rules?.find(rule => rule.name === ruleToSearch)) {
    //       hasRule = true;
    //     }
    //   });
    // }

    // if (!hasRule && currentUser?.rules?.find(rule => rule.name === ruleToSearch)) {
    //   hasRule = true;
    // }

    // return hasRule;
  }

  function findProfile(profileToSearch: string): boolean {
    // return true;
    let hasProfile = false;

    if (currentUser?.profiles?.find(profile => profile.name === profileToSearch)) {
      hasProfile = true;
    }
    return hasProfile;
  }

  return {
    isMaster: findProfile('ADMINISTRATOR') || findProfile('OPERATIONS'),

    canArchive: findRule('RULE_ADMIN_CAN_ARCHIVE'),
    canApproveDocumentApproval: findRule('RULE_CAN_APPROVE_DOCUMENT_APPROVAL'),
    canApproveCompliance: findRule('RULE_CAN_APPROVE_COMPLIANCE'),
    canApproveSpecialSituation: findRule('RULE_CAN_APPROVE_SPECIAL_SITUATION'),
    canApproveDisbursement: findRule('RULE_CAN_APPROVE_FUNDING_MANUAL'),
    canApprovePreFraud: findRule('RULE_ADMIN_CAN_APPROVE_PRE_FRAUD'),
    canApproveFraud: findRule('RULE_ADMIN_CAN_APPROVE_FRAUD'),
    canViewLogs: findRule('RULE_USER_CAN_VIEW_LOGS'),
    canApproveContractInformationApproval: findRule('RULE_CAN_APPROVE_CONTRACT_INFORMATION'),
    canApproveAdministratorTransfer: findProfile('RULE_CAN_APPROVE_ADM_TRANSFER'),
  };
};


// WEBPACK FOOTER //
// ./src/services/middleware/AuthPermissions.ts